module.exports = __webpack_public_path__ + "static/media/portfolio.9660ed00.jpg";